import React, { useState, useEffect, useRef } from "react";
import { Card } from "antd";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";

import CustomButton from "../../components/customButton";
import Layout from "../../components/layout";
import { messageLogColumns } from "../../constants/constants";
import BroadcastService from "../../service/BroadcastUserService";
import { setPopup } from "../../actions/popupAction";
import { downloadPatientFilesSagaAction } from "../../sagas/saga-fileDownload";
import loginService from "../../service/login";
import AntdTable from "../../components/antdTable";
import { ReportsButtonIcon } from "../../assets/svg";
import MobileHeader from "../../components/header/mobileHeader";
import "./styles.scss";

const MessageLog = (props) => {
  const broadcast = new BroadcastService();
  const filterRef = useRef(false);
  const history = useHistory();

  const [state, setState] = useState({
    data: [],
    loading: false,
    filteredTotal: 0,
    pageNo: 1,
    filters: {},
    sorter: "",
    dateFilter: {
      range: "random",
      isDownloading: false,
      endDate: moment().endOf("day"),
      startDate: moment()
        .startOf("day")
        .subtract(1, "days"),
    },
    resetDate: false,
  });

  const getMessageLogs = async () => {
    setState((st) => ({
      ...st,
      loading: true,
      data: [],
    }));
    const startDate =
      state.dateFilter.startDate !== undefined
        ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
        : null;
    const endDate =
      state.dateFilter.endDate !== undefined
        ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
        : null;
    const data = await broadcast.getMessageLogs(
      state.pageNo,
      15,
      null,
      null,
      startDate,
      endDate
    );
    setState((st) => ({
      ...st,
      data: data.data,
      filteredTotal: data.count,
      loading: false,
    }));
  };

  useEffect(() => {
    getMessageLogs();
  }, []);

  const hideReport = () => {
    history.push("/broadcast");
  };

  const copyToClipboard = (text) => {
    var dummy = document.createElement("input");
    document.body.appendChild(dummy);
    dummy.setAttribute("value", text);
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    handlePopupMessage();
  };

  const handlePopupMessage = () => {
    props.setPopup({
      customPopupMessage: true,
      messageType: "success",
      message: "Message has been copied to clipboard!",
    });
  };

  const onTableChange = async (pagination, _filters, sorterObj) => {
    const page = pagination.current;
    const field = sorterObj.field;
    const order = sorterObj.order
      ? sorterObj.order === "ascend"
        ? "asc"
        : "desc"
      : "";
    const sorter = field && order ? `${field}.${order}` : "";
    try {
      setState((st) => ({
        ...st,
        data: [],
        loading: true,
      }));
      const pageNo = sorter !== state.sorter ? 1 : page;
      const updatedFilters = JSON.stringify(state.filters);
      const startDate =
        state.dateFilter.startDate !== undefined
          ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
          : null;
      const endDate =
        state.dateFilter.endDate !== undefined
          ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
          : null;
      const result = await broadcast.getMessageLogs(
        pageNo,
        15,
        sorter,
        updatedFilters,
        startDate,
        endDate
      );
      setState((st) => ({
        ...st,
        pageNo,
        data: result.data,
        sorter,
        loading: false,
      }));
    } catch (e) {
      setState((st) => ({ ...st, loading: false }));
    }
  };

  const getSuggestions = async (key, value, filters) => {
    try {
      let attribute = key;
      const startDate =
        state.dateFilter.startDate !== undefined
          ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
          : null;

      const endDate =
        state.dateFilter.endDate !== undefined
          ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
          : null;

      const data = await broadcast.getLogsListSuggestions(
        attribute,
        value,
        filters,
        startDate,
        endDate
      );
      return data.data.map((item) => ({
        key: item[attribute],
        name: item[attribute],
      }));
    } catch {
      return [];
    }
  };

  const applyFilters = async (filters) => {
    if (filterRef && filterRef.current) return;
    else {
      filterRef.current = true;
      setState((st) => ({ ...st, filters, loading: true, data: [] }));
      try {
        let search = JSON.stringify(filters);
        const startDate =
          state.dateFilter.startDate !== undefined
            ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
            : null;
        const endDate =
          state.dateFilter.endDate !== undefined
            ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
            : null;

        const logs = await broadcast.getMessageLogs(
          state.pageNo,
          15,
          state.sorter,
          search,
          startDate,
          endDate
        );
        const rows = logs?.data;
        setState((st) => ({
          ...st,
          data: rows,
          filteredTotal: logs?.count,
          filters,
          pageNo: 1,
          total: logs?.count,
          loading: false,
        }));
        filterRef.current = false;
        return logs.data;
      } catch (e) {
        setState((st) => ({
          ...st,
          logs: [],
          loading: false,
        }));
        filterRef.current = false;
      }
    }
  };

  const getDateFilter = (selectedDate) => {
    setState((st) => ({
      ...st,
      dateFilter: selectedDate,
    }));
  };

  useEffect(
    () => {
      applyFilters(state.filters);
    },
    [state.dateFilter]
  );

  const showReports = async () => {
    history.push("/broadcast/report");
  };

  const decodedToken = loginService.getDecodedToken();
  const loggedinUser = decodedToken?.payload;

  return (
    <Layout testId="broadcast-messageLog-page-wrapper">
      <div className="header-bar-mob">
        <MobileHeader
          showLogo={false}
          showNotifications={false}
          showHelp={false}
          showAccountDetails={false}
          backgroundColor="gray-bg"
          showBackButton={true}
          showPageTitle={true}
          pageTitle="Message Log"
          handleBackButton={hideReport}
        />
      </div>
      <div className="inner-content-wrapper message-log-wrapper">
        <Card
          className="primary-card live-chat-card patient-report-card"
          title={<div>Message Log</div>}
          extra={
            <div className="close-container">
              {loggedinUser?.lcUser?.roles?.roleKey !== "BA" &&
                loggedinUser?.roles?.roleKey !== "BA" && (
                  <CustomButton
                    btntype="clear"
                    title="Close"
                    onClick={hideReport}
                    className="mr-8"
                  />
                )}
              {(loggedinUser?.lcUser?.roles?.roleKey === "BA" ||
                loggedinUser?.roles?.roleKey === "BA") && (
                <CustomButton
                  title={
                    <div className="icon-button">
                      <span className="message-icon">
                        <ReportsButtonIcon />
                      </span>
                      Broadcast Report
                    </div>
                  }
                  tooltip="Message Log"
                  btntype="primary"
                  className={
                    "cancel-button ml-8 reports-button message-log-new"
                  }
                  onClick={showReports}
                />
              )}
            </div>
          }
        >
          <AntdTable
            columns={messageLogColumns(copyToClipboard, state.dateFilter)}
            data={state.data}
            loading={state.loading}
            tableProps={{
              onChange: onTableChange,
              pagination: {
                filteredTotal: state.filteredTotal,
                current: state.pageNo,
              },
            }}
            searchPlaceholder="Search"
            getSuggestionsList={getSuggestions}
            filterFirstColumn={true}
            applyFilters={applyFilters}
            getDateFilter={getDateFilter}
            showDownload={false}
            startDate={moment()
              .startOf("day")
              .subtract(1, "days")}
            endDate={moment().endOf("day")}
            range="random"
          />
        </Card>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  popupReducer: state.popupReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
    downloadPatientFiles: (object, cb) => {
      dispatch(downloadPatientFilesSagaAction(object, cb));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageLog);
